import { RadioGroup as RadixRadioGroup } from "radix-ui";
import { ReactNode } from "react";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

interface RadioGroupProps
  extends Omit<RadixRadioGroup.RadioGroupProps, "children"> {
  value?: string;
  onValueChange?: (value: string) => void;
  name?: string;
  disabled?: boolean;
  className?: string;
  children: ReactNode;
}

export function RadioGroup({
  value,
  onValueChange,
  name,
  disabled,
  className,
  children,
  ...rest
}: RadioGroupProps) {
  return (
    <RadixRadioGroup.Root
      {...rest}
      value={value}
      onValueChange={onValueChange}
      name={name}
      disabled={disabled}
      className={twMerge(clsx("space-y-4", className))}
    >
      {children}
    </RadixRadioGroup.Root>
  );
}
